import axios from "axios";
import config from "../config";

export function getMeetingNotesTemplates() {
  return axios.get(`${config.api_url}/meeting-notes-templates`);
}

export function createMeetingNotesTemplate(data) {
  return axios.post(`${config.api_url}/meeting-notes-templates`, data);
}

export function updateMeetingNotesTemplate(id, data) {
  return axios.put(`${config.api_url}/meeting-notes-templates/${id}`, data);
}

export function deleteMeetingNotesTemplate(id) {
  return axios.delete(`${config.api_url}/meeting-notes-templates/${id}`);
}

export function setDefaultMeetingNotesTemplate(templateId) {
  return axios.put(`${config.api_url}/meeting-notes-templates/default`, {
    meeting_notes_template_id: templateId,
  });
}
